<template>
  <div style="width: 100%;margin-top: 87px;">
    <!--  轮播图  -->
    <div style="height: 660px;">
      <el-carousel :interval="4000" trigger="click" arrow="always" height="660px">
        <el-carousel-item v-for="(item, i) in imgList" :key="i">
          <el-row :style="{backgroundImage: 'url(' + item + ')', width: '100%', height: '100%', backgroundSize:'100% 100%', backgroundRepeat:'no-repeat'}">
          </el-row>
        </el-carousel-item>
      </el-carousel>
    </div>
    <el-row style="width: 100%;text-align: center;height: 150px;line-height: 150px;font-size: 34px;font-weight: bold;margin-top: 40px;">
      加入我们，共同富裕
    </el-row>
    <div style="width: 1300px;height: 680px;display: flex;margin-left: calc(50% - 650px);">
      <div style="width: 49%;height: 576px;margin-right: 2%">
        <el-row style="width: 100%;height: 120px;background-color: #00bf86;color: #fff;">
          <div style="font-size: 30px;height: 50px;margin-top: 24px;">全国诚招合作伙伴</div>
          <div style="font-size: 16px;">一切都为您准备好，助您轻松开展业务</div>
        </el-row>
        <el-row v-for="(item, i) in joinRemark" :key="i" style="width: 100%;padding: 0 12% 0 12%;height: 150px;background-color: rgba(0, 191, 134, 0.2);margin-top: 2px;color: #00bf86;text-align: justify;">
          <div style="font-size: 24px;height: 46px;" :style="{'margin-top': item.top}">{{item.title}}</div>
          <div style="font-size: 14px;color: #000;line-height: 22px;">{{item.detail}}</div>
        </el-row>
      </div>
      <div style="width: 49%;height: 576px;">
        <el-image :src="worthImage" fit="cover" style="height: 576px;"></el-image>
      </div>
    </div>
    <el-row style="width: 100%;background-color: #f6f6f6;height: 690px;">
      <div style="width: 100%;text-align: center;height: 140px;line-height: 140px;font-size: 34px;font-weight: bold;margin-top: 40px;">
        全方位服务与技术支持
      </div>
      <div style="width: 1300px;margin-left: calc(50% - 650px);height: 400px;display: flex;">
        <div v-for="(item, i) in support" :key="i" style="width: 284px;margin: 0 20px;background-color: #fff;border-radius: 14px;">
          <div style="width: 100px;margin: 60px 93px 0;height: 100px;border: 2px solid rgba(0, 191, 134, 0.6);border-radius: 52px;line-height: 100px;">
            <i :class="item.icon" style="font-size: 64px;color: #00bf86" />
          </div>
          <div style="font-size: 24px;line-height: 90px;">{{item.title}}</div>
          <div style="font-size: 14px;line-height: 32px;">
            <div v-for="(itemItem, j) in item.detail" :key="j">{{itemItem}}</div>
          </div>
        </div>
      </div>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'NewsPage',
  data() {
    return {
      imgList: [require('../../assets/img/contact/contact.jpg')],
      worthImage: require('../../assets/img/contact/worth.jpg'),
      joinRemark: [
        {top: '32px', title: '快速入行', detail: '瑜岿科技提供智慧能源产业链产品、技术、服务等全方位支持，让您轻松高效开展业务。'},
        {top: '18px', title: '资源变现', detail: '善用资源，快速变现！运用现有的人脉、信息等资源，与瑜岿科技携手，助您资源变现。 如果没有资源，瑜岿科技将提供资源支持；如需求信息资源，潜在客户资源等。'},
        {top: '36px', title: '长期收入', detail: '一次安装，长期收益，给您带来源源不断的财富。'}
      ],
      support: [
        {icon: 'yk-icon-xiaoshou', title: '销售支持', detail: ['提供智慧能源行业培训', '协助进行线上+线下宣传推广', '提供销售相关的物料支持']},
        {icon: 'yk-icon-chanping', title: '方案与产品支持', detail: ['提供全产业链智慧能源产品', '与各行业解决方案支持', '推进项目快速落地运营']},
        {icon: 'yk-icon-jishu', title: '技术支持', detail: ['提供 7×24 小时远程监控', '及相关的运维服务', '解决项目遇到的技术问题']},
        {icon: 'yk-icon-shouhou', title: '售后支持', detail: ['提供项目售后服务支持', '安全问题整改支持', '产品售后支持']}
      ]
    }
  },
  created() {
    document.documentElement.scrollTop = 0
  },
  methods: {
  }
}
</script>

<style scoped>
  .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 200px;
    margin: 0;
  }
  .menu-class {
     width: 85%;
     margin-top: 10px;
     height: 40px;
     line-height: 40px;
     background-color: #efefef;
     color: #000000;
     cursor: pointer;
   }
  .menu-class-hover {
    width: 85%;
    margin-top: 10px;
    height: 40px;
    line-height: 40px;
    background-color: #00bf86;
    color: #ffffff;
    cursor: pointer;
  }
  .menu-class:hover {
    background-color: #00bf86;
    color: #ffffff;
  }
  .title-class {
    height: 60px;
    line-height: 60px;
  }
  .title-class:hover {
    cursor: pointer;
    color: #00bf86;
  }
</style>



// WEBPACK FOOTER //
// src/components/contact/ContactPage.vue